import { useSessionContext } from '@shared/hooks'
import { App, Button, Form, Modal, Tooltip } from 'antd'
import { MessageQuestion } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TicketForm } from './TicketForm'

import { submitFormToTeamworkBasic } from '../utils'

import type { TicketFormState } from '@organization/features/tickets/types'

const environment = import.meta.env.VITE_APP_ENV

export const Tickets = () => {
  const { user } = useSessionContext()

  const [isLoading, setIsLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const [form] = Form.useForm<TicketFormState>()
  const { message } = App.useApp()
  const { t } = useTranslation()

  const onSubmit = async () => {
    const values = await form.validateFields()
    setIsLoading(true)

    const payload: TicketFormState = {
      ...values,
      url: window.location.href,
      attachments: values.attachments,
      user,
      environment
    }

    await submitFormToTeamworkBasic(payload)
    message.success(t('tickets.ticket_success_create'))
    onCancel()
    setIsLoading(false)
  }

  const onModalOpen = () => setIsModalOpen((prev) => !prev)

  const onCancel = () => {
    form.resetFields()
    setIsModalOpen(false)
  }

  return (
    <>
      <Tooltip title={t('tickets.create')}>
        <Button
          onClick={onModalOpen}
          type="text"
          icon={<MessageQuestion size={20} />}
        />
      </Tooltip>

      <Modal
        open={isModalOpen}
        onOk={onSubmit}
        onCancel={onCancel}
        okText={t('button.submit')}
        okButtonProps={{ loading: isLoading }}
        width={600}
        centered
        destroyOnHidden
      >
        <TicketForm form={form} />
      </Modal>
    </>
  )
}
